export default {
  direct: 'Direkt',
  stops: 'stopp',
  stop: 'stopp',
}
